import { render, staticRenderFns } from "./datiRecordList.vue?vue&type=template&id=3db66eb6&"
import script from "./datiRecordList.vue?vue&type=script&lang=js&"
export * from "./datiRecordList.vue?vue&type=script&lang=js&"
import style0 from "./datiRecordList.vue?vue&type=style&index=0&id=3db66eb6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports